export enum actionTypes {
  FETCH_VIDEO_SERIES_REQUEST = "FETCH_VIDEO_SERIES_REQUEST",
  FETCH_VIDEO_SERIES_SUCCESS = "FETCH_VIDEO_SERIES_SUCCESS",
  FETCH_VIDEO_SERIES_FAIL = "FETCH_VIDEO_SERIES_FAIL",
  //create series
  CREATE_VIDEO_SERIES_REQUEST = "CREATE_VIDEO_SERIES_REQUEST",
  CREATE_VIDEO_SERIES_SUCCESS = "CREATE_VIDEO_SERIES_SUCCESS",
  CREATE_VIDEO_SERIES_FAIL = "CREATE_VIDEO_SERIES_FAIL",
  //update series
  UPDATE_VIDEO_SERIES_REQUEST = "UPDATE_VIDEO_SERIES_REQUEST",
  UPDATE_VIDEO_SERIES_SUCCESS = "UPDATE_VIDEO_SERIES_SUCCESS",
  UPDATE_VIDEO_SERIES_FAIL = "UPDATE_VIDEO_SERIES_FAIL",
  //delete series
  DELETE_VIDEO_SERIES_REQUEST = "DELETE_VIDEO_SERIES_REQUEST",
  DELETE_VIDEO_SERIES_SUCCESS = "DELETE_VIDEO_SERIES_SUCCESS",
  DELETE_VIDEO_SERIES_FAIL = "DELETE_VIDEO_SERIES_FAIL",
}

export interface GenericVideoSeriesStateProps {
  isLoading: boolean;
  status: stateStatusType | string;
  error: string | null;
}

export enum stateStatusType {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export interface VideoSeriesInput {
  title: string;
  series_order: number;
  category_folder_id: string;
  category_id: string;
}
export interface UpdateSeriesInput {
  title: string;
  series_order: number;
  category_id?: string;
  series_id: string;
  folder_id: string;
}

export interface VideoSeriesProps {
  title: string;
  id: string;
  series_order: number;
  folder_id: string;
}

//FetchVideoSeries
export interface FetchVideoSeriesRequestAction {
  type: actionTypes.FETCH_VIDEO_SERIES_REQUEST;
}

export interface FetchVideoSeriesSuccessAction {
  type: actionTypes.FETCH_VIDEO_SERIES_SUCCESS;
  payload: VideoSeriesProps[];
}

export interface FetchVideoSeriesFailureAction {
  type: actionTypes.FETCH_VIDEO_SERIES_FAIL;
  payload: string;
}

//CreateVideoSeries
export interface CreateVideoSeriesSuccessAction {
  type: actionTypes.CREATE_VIDEO_SERIES_SUCCESS;
  payload: VideoSeriesProps;
}
export interface CreateVideoSeriesFailAction {
  type: actionTypes.CREATE_VIDEO_SERIES_FAIL;
  payload: string;
}

//UpdateVideoSeries
export interface UpdateVideoSeriesSuccessAction {
  type: actionTypes.UPDATE_VIDEO_SERIES_SUCCESS;
  payload: VideoSeriesProps;
}
export interface UpdateVideoSeriesFailAction {
  type: actionTypes.UPDATE_VIDEO_SERIES_FAIL;
  payload: VideoSeriesProps;
}

//DeleteVideoSeries
export interface DeleteVideoSeriesSuccessAction {
  type: actionTypes.DELETE_VIDEO_SERIES_SUCCESS;
  payload: string;
}
export interface DeleteVideoSeriesFailAction {
  type: actionTypes.DELETE_VIDEO_SERIES_FAIL;
  payload: string;
}

export type VideoSeriesActions =
  | FetchVideoSeriesRequestAction
  | FetchVideoSeriesSuccessAction
  | FetchVideoSeriesFailureAction
  | CreateVideoSeriesSuccessAction
  | CreateVideoSeriesFailAction
  | UpdateVideoSeriesSuccessAction
  | UpdateVideoSeriesFailAction
  | DeleteVideoSeriesSuccessAction
  | DeleteVideoSeriesFailAction
